<template>
    <v-container>
        <div v-if="showcargando" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row>
            <v-card width="100%" class="mx-1">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-card class="text-xs-center ma-1">
                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white;">OpenAI Vehiculo Detenido</span>
                    </v-card-title>
                    <v-card-text v-if="mostrar">
                        <v-row>
                            <v-col cols="12" class="text-center">
                                <v-data-table :headers="encabezado" :items="datosOriginales" :items-per-page="20"
                                    class="elevation-1" :footer-props="footerProps"></v-data-table>
                            </v-col>
                        </v-row>
                        <v-row v-if="iniciar">
                            <v-col cols="12" class="text-center">
                                <v-btn class="ma-2" @click="Iniciar()" color="primary" :loading="btnloading">
                                    Iniciar análisis
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row v-else>
                            <v-col cols="12" class="text-center">
                                <v-btn class="ma-2" @click="Regresar()" color="error">
                                    Reiniciar proceso
                                </v-btn>
                            </v-col>
                        </v-row>
                        <template v-if="showTabla">
                            <v-row>
                                <v-col cols="12" class="text-center">
                                    <template>
                                        <v-data-table :headers="headers" :items="datos" :items-per-page="20"
                                            class="elevation-1" :footer-props="footerProps">
                                            <template v-slot:[`item.Vehiculo`]="{ item }">
                                                <td class="custom-column">{{ item.Vehiculo }}</td>
                                            </template>

                                        </v-data-table>
                                    </template>
                                </v-col>
                            </v-row>
                        </template>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import Sistemas from "@/services/Sistemas/sistemas.service.js";
import Menu from '@/components/pages/Sistemas/MenuSistemas.vue';

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        Menu,
    },
    data() {
        return {
            showcargando: true,
            datos: {},
            headers: [
                { text: 'Reporte', value: 'Reporte' },
                { text: 'Observación', value: 'Observacion' },
                { text: 'Vehiculo Liberado', value: 'Vehiculo' },
                { text: 'Cuenta con documento', value: 'HayDoc' },
            ],
            mostrar: false,
            showTabla: false,
            encabezado: [
                { text: 'Reporte', value: 'Reporte' },
                { text: 'Observación', value: 'ObservacionesMovimiento' },
            ],
            datosOriginales: {},
            iniciar: true,
            btnloading: false,
            footerProps: {
                'items-per-page-text': 'Filas por página:', // Traducción de 'Rows per page'
                'page-text': '{0}-{1} de {2}',               // Traducción de 'x of y'
                'items-per-page-options': [20, 30, -1]
            }
        }

    },
    computed: {
        ...mapState(['permission', 'domain']),
        ...mapGetters(['getUser', 'THEME_STATE'])
    },
    methods: {
        async Iniciar() {
            this.btnloading = true;
            let response = await Sistemas.ConsultarOpenAIVH();
            /* let response = {
                error: false,
                respuestas: {
                    0: {
                        archivo: null,
                        correcto: false,
                        error: false,
                        msg: '```json\n[\n    {\n        "Reporte": "1376954-1",\n        "Vehiculo": "No"\n    },\n    {\n        "Reporte": "1389280-1",\n        "Vehiculo": "Si"\n    },\n    {\n        "Reporte": "1389591-1",\n        "Vehiculo": "No"\n    },\n    {\n        "Reporte": "1389593-1",\n        "Vehiculo": "No"\n    },\n    {\n        "Reporte": "1389717-1",\n        "Vehiculo": "No"\n    }\n]\n```',
                        pagina: null,
                        watch: null
                    }
                }
            } */
            console.log('response', response)

            let auxDatos = []
            if (!response.error) {
                let partes = response.respuestas[0].msg.split(/```json\n|\n```/);
                let combinedData = partes
                    .filter(str => str.trim() !== "") // Eliminar elementos vacíos o espacios
                    .map(str => JSON.parse(str)) // Convertir las cadenas a objetos JSON
                    .flat(); // Unir todos los arrays en uno solo

                const transformedData = combinedData.map(item => {
                    // Buscar la observación correspondiente en datosOriginales
                    const originalData = this.datosOriginales.find(
                        original => original.Reporte === item.Reporte
                    );

                    return {
                        "Reporte": item.Reporte,
                        "Vehiculo": item.Vehiculo,
                        ...(originalData && { "Observacion": originalData.ObservacionesMovimiento }) // Agrega si hay Observacion
                    };
                });

                // Concatenar con auxDatos
                auxDatos = auxDatos.concat(transformedData);

                this.datos = auxDatos

                let reportesA = [], svindicesA = []

                this.datos.forEach(async item => {
                    if (item.Vehiculo == 'Si') {
                        let aux = item.Reporte.split('-');
                        let _svindice = aux[1];
                        let _nrreporte = aux[0];
                        reportesA.push(_nrreporte);
                        svindicesA.push(_svindice);
                    }
                });

                if (reportesA.length > 0) {
                    let response2 = await Sistemas.ComprobarDocumento(reportesA.join(','), svindicesA.join(','));

                    const response2Map = new Map();
                    response2.forEach(item => {
                        response2Map.set(item.Reporte, item);  // Suponiendo que response2 tiene 'Reporte'
                    });

                    const combinedData = this.datos.map(item => {
                        const matchingResponse = response2Map.get(item.Reporte);  // Buscar el Reporte en el Map

                        return {
                            ...item,  // Mantener los datos originales de this.datos
                            ...(matchingResponse && { ...matchingResponse })  // Combinar con datos de response2 si hay coincidencia
                        };
                    });
                    this.datos = combinedData
                }
                this.showTabla = true;
                this.iniciar = false;

            } else {
                this.$swal({
                    position: "center",
                    icon: "warning",
                    title: "Error",
                    text: "Ocurrió un error, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.",
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    timer: 2500,
                });
            }
            this.btnloading = false;
        },
        async Regresar() {
            this.mostrar = true;
            this.iniciar = true;
            this.showTabla = false;
            await this.ObtenerDatosIniciales()
        },
        async ObtenerDatosIniciales() {
            let response = await Sistemas.DatosaConsultar(1);
            this.datosOriginales = response;

            this.showcargando = false;
            this.mostrar = true;
        }
    },
    async mounted() {
        await this.ObtenerDatosIniciales();
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '357').then(response => {
            if (response.data.length > 0) {
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    }
}
</script>

<style>
.custom-column {
    background-color: #536dfe3c;
}
</style>